import type { HebeModel } from '@sbt-web/adv';

const advFallbackConfigMsite: HebeModel = {
  name: 'userprofile',
  page_level_settings: {},
  slots: [],
};

export { advFallbackConfigMsite };
